import { Tooltip } from '@devforce/tds-react';
import WithIconSettings from 'components/utils/withIconSettings';

export default WithIconSettings(Tooltip);
